import { lgMarginBottomStyles } from "../../neutral/styles/spacing";
import { css, SerializedStyles } from "@emotion/react";
import { SmallDivider } from "@minted/fancyclothes";
import React from "react";

const centeredStyles = css`
  text-align: center;
`;

const marginTopStyles = css`
  margin-top: 2rem;
`;

export type PageContentSeparatorProps = {
  extraStyles?: SerializedStyles[];
  isCentered?: boolean;
};

const PageContentSeparator = ({
  extraStyles = [],
  isCentered,
}: PageContentSeparatorProps) => (
  <div
    css={[
      lgMarginBottomStyles,
      marginTopStyles,
      isCentered && centeredStyles,
      ...(Array.isArray(extraStyles) ? extraStyles : [extraStyles]),
    ]}
    data-cy="secondarySeparator"
  >
    <SmallDivider />
  </div>
);

PageContentSeparator.displayName = "PageContentSeparator";

export default PageContentSeparator;
